// extracted by mini-css-extract-plugin
export var black = "_1e-6";
export var brand = "_1e-1";
export var ddefault = "_1e-0";
export var error = "_1e-3";
export var gray = "_1e-2";
export var highContrast = "_1e-8";
export var outline = "_1e-7";
export var success = "_1e-5";
export var warning = "_1e-4";